import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';

import { DATATABLE_CONFIG, EMPLOYEE_SUBMENU_ID,DROPDOWN_CONFIG } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import { MultiSelect } from 'primereact/multiselect';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { generateEmploymentContractPdf } from './EmploymentContractPdfTemplate';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { RadioButton } from 'primereact/radiobutton';
import { generatePositionPdf } from './PositionPdf';

// Same option lists the Add/Edit Employee form uses to store these values
const EMPLOYEE_TYPE_LABELS = { 1: 'Permanent', 2: 'Contract' };
const WEEKLY_OFF_LABELS = { 1: 'One day', 2: 'Two day', 3: 'Three day', 4: 'No weekly Off' };

class EmployeeMaster extends Component {
    state = {
        display : true,
        departmentList : [
            {
                label: '---Select Concerned Department---',
                value : null
            },
            {
                label: 'IT',
                value : 'IT'
            },
            {
                label: 'Finance Mangement',
                value : 'Finance Mangement'
            }
        ],
        dataTableValue: [{
            empno : "6000449",
            emptype : "Permanent",
            firstname : "Kristeine Lim",
            position : "Demo System Auto Generated",
            email : "swcaldt1ws@inbox-me.top",
            reporting : "COMPENSATION & BENEFITS"
        },{
            empno : "6000450",
            emptype : "Permanent",
            firstname : "Kristeine Lim",
            position : "Demo System Auto Generated",
            email : "swcaldt1ws@inbox-me.top",
            reporting : "Siddiq"
        },
        {
            empno : "6000451",
            emptype : "Permanent",
            firstname : "Kristeine Lim",
            position : "Demo System Auto Generated",
            email : "swcaldt1ws@inbox-me.top",
            reporting : "Siddiq"
        }
    ],

    selectedItems:[],


    //new for Additional column visibilty 
    columnOptions: [
        // Default columns (disabled = always visible)
        { label: 'Employee Name', value: 'employeeName', disabled: true },
        { label: 'User No', value: 'userNo', disabled: true },
        { label: 'Position Description', value: 'postiondescription' },
        { label: 'Position No', value: 'positionnumber' },
        { label: 'Org No', value: 'orgNo' },
        { label: 'Dept Name', value: 'name' },
        // Additional columns
        { label: 'Cost Center', value: 'costcenter' },
        { label: 'Employee Subgroup', value: 'empsubgrp' },
        { label: 'Nationality', value: 'nationalityNames' },
        { label: 'Gender', value: 'gender' },
        { label: 'Vendor', value: 'vendor' },
        { label: 'Emp Type', value: 'employeetypeid' },
        { label: 'Employee Status', value: 'employeeStatus' },
        { label: 'Demoblize Date', value: 'demobilizedate' },
        { label: 'Demoblize Remark', value: 'demobilizeremark' },
    ],
    // Default selected columns (initially show these)
    selectedColumns: JSON.parse(localStorage.getItem('employeeMasterSelectedColumns')) || ['employeeName', 'userNo', 'postiondescription', 'positionnumber', 'orgNo', 'name'],
      //changed for manage loading screen when fetching keywords
       keywordLoading: false,
       contractDialogVisible: false,
       contractRowData: null,
       contractOption: 'with'
}

    // new for Handle column selection change
    // onColumnToggle = (e) => {
    //     this.setState({ selectedColumns: e.value });
    // }


    // Method to download selected employees as Excel
 downloadEmptyContract = () => {
        // The PDF stored on the server (wwwroot\EmployeeContract) is downloaded as-is; nothing is generated here.
        const fileName = 'Employment_Contract_Template.pdf';
        axios({
            url: `/master/api/Download?filename=${encodeURIComponent(fileName)}&&FolderName=EmployeeContract&&ext=.pdf`,
            method: 'GET',
            responseType: 'blob',
        })
            .then(response => saveAs(new Blob([response.data], { type: 'application/pdf' }), fileName))
            .catch(() => alert('Unable to download the contract template.'));
    }

    downloadSelectedEmployeesExcel = () => {
        const { selectedItems, columnOptions } = this.state;

        if (!selectedItems || selectedItems.length === 0) return;

        // Define standard column order (fields)
        const standardOrder = [
            'employeeName',
            'userNo',
            'postiondescription',
            'positionnumber',
            'orgNo',
            'name',
            'costcenter',
            'empsubgrp',
            'nationalityNames',
            'gender',
            'vendor',
            'employeetypeid',
            'employeeStatus',
            'demobilizedate',
            'demobilizeremark',
        ];

       const exportOrder = standardOrder.filter(field => this.state.selectedColumns.includes(field));
        // Map to headers using columnOptions
        const header = exportOrder.map(field =>
            (columnOptions.find(col => col.value === field) || {}).label || field
        );

        // Prepare rows in standard order
        const rows = selectedItems.map(emp =>
            exportOrder.map(field => {
                if (field === 'empsubgrp') {
                    return emp['empsubgrplabel'] || '';
                }
                if (field === 'vendor') {
                    return emp['vendorname'] || '';
                }
                if (field === 'employeeStatus') {
                    return emp['employeeStatuslabel'] || '';
                }
                if (field === 'demobilizedate') {
                    return emp['demobilizedateFormatted'] || '';
                }
                return emp[field] || '';
            })
        );

        // Combine header and rows
        const worksheetData = [header, ...rows];

        // Create worksheet and workbook
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Set column widths for better spacing in Excel
        worksheet['!cols'] = header.map(() => ({ wch: 20 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");

        // Generate Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, "Employee_List.xlsx");
    }
    //changed 
    onColumnToggle = (e) => {
        const selected = e.value;
        // Save selected columns to localStorage
        localStorage.setItem('employeeMasterSelectedColumns', JSON.stringify(selected));
        
        this.setState({ selectedColumns: selected }, () => {
            // lazy load vendor keywords only when vendor column selected and not loaded
     if (selected.includes('vendor') && (!this.props.vendor || this.props.vendor.length === 0)) {
                this.setState({ keywordLoading: true });
                this.props.getMasterKeywordList('vendor');
            }
            
            if (selected.includes('empsubgrp') && (!this.props.employeesubgroup || this.props.employeesubgroup.length === 0)) {
                this.setState({ keywordLoading: true });
                this.props.getMasterKeywordList('employeesubgroup/keyword');
            }
        });
    }

            //changed
    // To get the keyword names from keyword values(id)
getKeywordText = (keywordType, id) => {

    const keywordArray = this.props[keywordType];
    if (!keywordArray || !id) return '';
    const idStr = id.toString().trim();
    
    // ✅ Define matching field based on keywordType
    const matchField = keywordType === 'vendor' ? 'value' : 'id';
    
    const item = keywordArray.find(keyword =>
        keyword[matchField] && keyword[matchField].toString().trim() === idStr
    );
    
    return item ? item.label : '';
}
//changed

    canViewAllEmployeeRecords = () => {
        const roleValue = String(
            (this.props.loggedUserDetail && this.props.loggedUserDetail.role) || localStorage.getItem('UserRole') || ''
        ).toLowerCase();
        const privilegedRoleCodes = ['80', '85', '90'];
        const isHrTeam = !!parseInt(localStorage.getItem('hrTeam'), 10);
        const isPrivilegedByCode = privilegedRoleCodes.includes(roleValue);
        // const isPrivilegedByName = roleValue.includes('hr') || roleValue.includes('manager');

        return isHrTeam || isPrivilegedByCode ;
    }

    isCurrentUserRow = (row, loggedEmpId) => {
        const normalize = value => (value !== null && value !== undefined ? String(value).trim() : '');
        const currentEmpId = normalize(loggedEmpId);
        const rowIdentifiers = [
            row && row.employeeId,
            row && row.employeeID,
            row && row.empID,
            row && row.empId,
            row && row.userNo,
            row && row.empno,
            row && row.employeeNo,
            row && row.userId,
            row && row.userID
        ].map(normalize);

        return currentEmpId !== '' && rowIdentifiers.includes(currentEmpId);
    }



   

    // Maps a selected employee's rowData to the Employment Contract template fields.
    // Only values present in rowData are used - nothing is hardcoded. Fields with no
    // corresponding rowData value are left blank ('') for now.
    mapEmployeeToContractFields = (rowData) => {
        if (!rowData) return {};

        const get = (...keys) => {
            for (const key of keys) {
                const value = rowData[key];
                if (value !== undefined && value !== null && value !== '') {
                    return value;
                }
            }
            return '';
        };

        // Full name = firstname + middlename + lastname (exact API field names); the grid's
        // employeeName is only a fallback when none of the three is available.
        const fullName = ([get('firstname'), get('middlename'), get('lastname')]
            .map(part => String(part).trim()).filter(Boolean).join(' ') || String(get('employeeName')).trim());

        return {
            // 1. Parties
            employeeName: fullName,
            employeeAddress: get('address'),
            employeeIdNumber: get('aadhaarnumber', 'iqama'),
            employeeMobileNo: get('mobileno'),
            fatherOrSpouseName: get('bankAljazeeera'),          // "Father Name" on the Employee Master
            emergencyContact: get('phone'),                      // "Emergency Contact" on the Employee Master

            // 2. Appointment & Job Details
            designation: get('postiondescription', 'positiondescription', 'positionEn'),
            department: get('name', 'description'),
            dateOfJoining: get('dateOfJoin', 'doj'),
            employmentType: (() => {
                const typeValue = get('employeetypeid', 'employeeTypeId', 'Employeetypeid');
                return EMPLOYEE_TYPE_LABELS[typeValue] || (typeof typeValue === 'string' ? typeValue : '');
            })(),
            probationPeriod: get('probationperiod'),
            reportingTo: get('reportingtoemployeename', 'reporting'),
            workLocation: get('bankRiyadh'),

            // 3. Working hours
            dailyWorkHours: get('bankEnma', 'bankenma'),
            breakTime: get('bankNcb'),
            weeklyOff: WEEKLY_OFF_LABELS[get('bankFranci')] || '',

            // 4. Salary & Benefits (Basic Salary from the Allowance & Deduction section)
            basicSalary: get('salaryBasic'),
            // salarytype is a keyword id; only a readable value is used
            salaryType: /^[0-9a-f-]{32,36}$/i.test(String(get('salarytype'))) ? '' : get('salarytype'),
            // paytype is a keyword id; generateContract resolves it to its label
            paymentType: /^[0-9a-f-]{32,36}$/i.test(String(get('paytype'))) ? '' : get('paytype'),

            // 12. Termination, Resignation & Notice
            noticePeriod: get('bankSamba', 'banksamba', 'noticeperiod'),

            // Fields with no corresponding source in the Employee Master - left blank intentionally
            employerName: '',
            employerAddress: '',
            normalShiftFrom: '',
            normalShiftTo: '',
        };
    }

    // The Employee Master grid row only carries a small subset of fields (name, position,
    // department, etc.). The remaining contract fields (address, mobile, date of joining,
    // salary, probation period, ID numbers, ...) only exist on the full employee record, so
    // it is fetched here and merged on top of the grid row before mapping to the template.
    fetchFullEmployeeRecord = (rowData) => {
        const employeeId = rowData && rowData.employeeId;
        const companyId = this.props.loggedUserDetail && this.props.loggedUserDetail.CompanyId;
        if (!employeeId) {
            return Promise.resolve({ merged: rowData, employeePosition: null });
        }

        return axios.get(`/master/api/GetEmployeeMaster?Employee_id=${employeeId}&Company_Id=${companyId}`)
            .then((response) => {
                const body = (response && response.data) || {};
                const employee = body.employee;
                const employeePosition = Array.isArray(body.employeePosition) ? body.employeePosition[0] : null;
                if (!employee) return { merged: rowData, employeePosition };
                // rowData's already-working, human-readable fields (designation, department,
                // employment type label, status, etc.) take priority over the raw record.
                // Empty grid values must not wipe out the full record's values.
                const filledRow = Object.keys(rowData || {}).reduce((acc, key) => {
                    const v = rowData[key];
                    if (v !== undefined && v !== null && v !== '') acc[key] = v;
                    return acc;
                }, {});
                return { merged: { ...employee, ...filledRow }, employeePosition };
            })
            .catch((error) => {
                console.error('Failed to fetch full employee record for contract generation:', error);
                return { merged: rowData, employeePosition: null };
            });
    }

    // Fetches the employee's position (getposition?Id=) which carries the position details and
    // the roles & responsibilities. Returns the position record merged with its responsibilities.
    fetchPositionRecord = (positionId) => {
        if (!positionId) return Promise.resolve(null);
        return axios.get(`/master/api/getposition?Id=${positionId}`)
            .then((response) => {
                const body = (response && response.data) || {};
                const record = (Array.isArray(body.positionList) && body.positionList.length > 0)
                    ? body.positionList[0]
                    : (body.position || (body.id !== undefined ? body : null));
                if (!record) return null;
                return {
                    ...record,
                    positionRoles: record.positionRoles !== undefined ? record.positionRoles : body.positionRoles,
                    resRolesResponsibilitiesList: record.resRolesResponsibilitiesList !== undefined
                        ? record.resRolesResponsibilitiesList : body.resRolesResponsibilitiesList,
                };
            })
            .catch((error) => {
                console.error('Failed to fetch position record for contract generation:', error);
                return null;
            });
    }

    // Maps the getposition response onto the contract's position + roles & responsibilities fields.
    mapPositionToContractFields = (position) => {
        if (!position) return {};
        const list = Array.isArray(position.resRolesResponsibilitiesList) ? position.resRolesResponsibilitiesList : [];
        const first = list[0] || {};
        return {
            positionName: position.name || '',
            positionDescription: position.description || '',
            positionNo: position.positionNo || '',
            jobPurpose: first.jobPurpose || '',
            positionDepartment: first.department || '',
            positionReportsTo: first.reportsTo || '',
            responsibilities: list
                .map(item => ({
                    responsibility: item.keyResponsibilities || '',
                    kpis: item.suggestedKpis || '',
                }))
                .filter(item => item.responsibility || item.kpis),
        };
    }

    // Calls GetEmployeeMaster and then getposition (the position id comes from the employee
    // record), maps both responses onto the contract template fields, generates the completed
    // Employment Contract as a .docx and downloads it.
    // Resolves a keyword id (e.g. paytype / salarytype) to its readable label.
    fetchKeywordLabel = (keyword, id) => {
        if (id === undefined || id === null || id === '') return Promise.resolve('');
        return axios.get(`/master/api/DropDownValues/${keyword}`)
            .then((response) => {
                const list = Array.isArray(response && response.data) ? response.data : [];
                const idStr = String(id).trim().toLowerCase();
                const item = list.find(entry => [entry.id, entry.uniqueId, entry.requestNum, entry.value]
                    .some(candidate => candidate !== undefined && candidate !== null && String(candidate).trim().toLowerCase() === idStr));
                return item ? (item.text || item.label || '') : '';
            })
            .catch(() => '');
    }

    // Opens the With / Without popup; the actual generation runs on OK.
    generateContract = (rowData) => {
        this.setState({ contractDialogVisible: true, contractRowData: rowData, contractOption: 'with' });
    }

    confirmGenerateContract = () => {
        const { contractRowData, contractOption } = this.state;
        this.setState({ contractDialogVisible: false });
        this.runGenerateContract(contractRowData, contractOption === 'with');
    }

    runGenerateContract = (rowData, withPositionPdf) => {
        let resolvedPositionId = null;
        this.fetchFullEmployeeRecord(rowData).then(({ merged: mergedEmployeeData, employeePosition }) => {
            const positionId = (employeePosition && employeePosition.positionId)
                || (mergedEmployeeData && mergedEmployeeData.positionId);
            resolvedPositionId = positionId;
            return Promise.all([
                this.fetchPositionRecord(positionId),
                this.fetchKeywordLabel('paytype/keyword', mergedEmployeeData && mergedEmployeeData.paytype),
                this.fetchKeywordLabel('salarytype/keyword', mergedEmployeeData && mergedEmployeeData.salarytype),
            ]).then(([position, paymentTypeLabel, salaryTypeLabel]) => ({ mergedEmployeeData, position, paymentTypeLabel, salaryTypeLabel }));
        }).then(({ mergedEmployeeData, position, paymentTypeLabel, salaryTypeLabel }) => {
            const positionFields = this.mapPositionToContractFields(position);
            const contractFields = { ...this.mapEmployeeToContractFields(mergedEmployeeData), ...positionFields };
            if (paymentTypeLabel) contractFields.paymentType = paymentTypeLabel;
            if (salaryTypeLabel && !contractFields.salaryType) contractFields.salaryType = salaryTypeLabel;
            // Position master is the source of truth for the designation when available.
            if (positionFields.positionName) contractFields.designation = positionFields.positionName;
            if (!contractFields.department && positionFields.positionDepartment) contractFields.department = positionFields.positionDepartment;
            if (!contractFields.reportingTo && positionFields.positionReportsTo) contractFields.reportingTo = positionFields.positionReportsTo;
            this.setState({ selectedEmployeeForContract: mergedEmployeeData, contractFieldMapping: contractFields });

            const employeeName = contractFields.employeeName || (rowData && rowData.employeeId) || 'Employee';
            const fileName = `Employment_Contract_${String(employeeName).replace(/[^a-zA-Z0-9]+/g, '_')}.pdf`;

            // Fills the Employment_Contract_Template (6).pdf template with the same mapped fields
            generateEmploymentContractPdf(contractFields)
                .then((pdfBlob) => saveAs(pdfBlob, fileName))
                .catch((error) => {
                    console.error('Failed to generate employment contract:', error);
                    alert('Unable to generate the employment contract: ' + ((error && error.message) || error));
                });

            if (withPositionPdf) {
                generatePositionPdf(resolvedPositionId)
                    .then((result) => {
                        if (result) setTimeout(() => saveAs(result.blob, result.fileName), 500);
                        else alert('Position PDF is not available for this employee.');
                    })
                    .catch((error) => console.error('Failed to generate position PDF:', error));
            }
        });
    }

    actionTemplate = (rowData, column) => {
        //let rowIndex = column.rowIndex;
        console.log("employee row:",rowData)
        return <div className="actionCenter">

            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
            <Link to={"/employee-master/edit/"+rowData.employeeId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }

            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
            <Link to={"/employee-master/view/"+rowData.employeeId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }

            <Button type="button" label="Generate Contract" icon="pi pi-file" className="p-button-success" onClick={() => this.generateContract(rowData)}></Button>

        </div>;
    }


  

    componentDidMount(){        

        this.props.getMasterTableList('GetEmployeeList');

        this.props.getMasterKeywordList('EmployeeStatus')

                   

         
        


        //new - Load keywords if persisted columns include them
        const { selectedColumns } = this.state;
        if (selectedColumns.includes('vendor') && (!this.props.vendor || this.props.vendor.length === 0)) {
            this.props.getMasterKeywordList('vendor');
        }
        if (selectedColumns.includes('empsubgrp') && (!this.props.employeesubgroup || this.props.employeesubgroup.length === 0)) {
            this.props.getMasterKeywordList('employeesubgroup/keyword');
        }
        if (selectedColumns.includes('employeeStatus') && (!this.props.employeestatus || this.props.employeestatus.length === 0)) {
             
        }

        this.getAccess = HASACCESS(EMPLOYEE_SUBMENU_ID);
    }
        //changed
        componentDidUpdate(prevProps) {
        if ((prevProps.vendor.length === 0 && this.props.vendor.length > 0) ||
            (prevProps.employeesubgroup.length === 0 && this.props.employeesubgroup.length > 0)) {
            this.setState({ keywordLoading: false });
        }
    }

  
    render() { 
        //  console.log("Employee Master Props:", this.props); // For debugging
        const header = (
            <div className="p-grid" style={{ marginBottom: '0.5em', display: 'flex', gap: '10px', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                    <Button label="Employee List" icon="pi pi-download" onClick={this.downloadSelectedEmployeesExcel} style={{ maxWidth: '300px' }} />
                    <Button label="Contract Empty Download" icon="pi pi-file-word" className="p-button-secondary" onClick={this.downloadEmptyContract} style={{ maxWidth: '300px', marginLeft: '10px' }} />
                </div>
                <div style={{ flex: 1 }}>
                    <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." style={{ width: '100%' }} />
                </div>
            </div>
        );

        let tableData = []    
        if(this.props.tableLists && this.props.tableLists.length > 0){
            tableData = this.props.tableLists;
        }

        //changed 
        if(this.props.tableLists && this.props.tableLists.length > 0 && (this.props.vendor.length>0 || this.props.employeesubgroup.length>0 || this.props.employeestatus.length>0  || this.state.selectedColumns.includes('demobilizedate')  )){
            tableData = this.props.tableLists.map(row => ({
                ...row,
                vendorname: this.getKeywordText('vendor', row.vendorId),
                empsubgrplabel: this.getKeywordText('employeesubgroup', row.empsubgrp),  
                employeeStatuslabel: this.getKeywordText('employeestatus', row.demobilizestatus),
                demobilizedateFormatted: row.demobilizedate ? moment(row.demobilizedate).format('MM/DD/YYYY') : 'N/A',

            }))
            //End changed   
        }

        const loggedEmpId = this.props.loggedUserDetail && this.props.loggedUserDetail.empID;
        if (!this.canViewAllEmployeeRecords() && loggedEmpId) {
            tableData = tableData.filter(row => this.isCurrentUserRow(row, loggedEmpId));
        }
    

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }


        return (
            <div className="p-grid padding">
               <Dialog header="Generate Contract" visible={this.state.contractDialogVisible} modal={true} style={{ width: '350px' }}
                    onHide={() => this.setState({ contractDialogVisible: false })}
                    footer={<Button label="OK" icon="pi pi-check" onClick={this.confirmGenerateContract} />}>
                    <div style={{ marginBottom: '0.8em' }}>
                        <RadioButton inputId="contractWith" name="contractOption" value="with" checked={this.state.contractOption === 'with'} onChange={() => this.setState({ contractOption: 'with' })} />
                        <label htmlFor="contractWith" style={{ marginLeft: '0.5em' }}>With (Contract PDF + Position PDF)</label>
                    </div>
                    <div>
                        <RadioButton inputId="contractWithout" name="contractOption" value="without" checked={this.state.contractOption === 'without'} onChange={() => this.setState({ contractOption: 'without' })} />
                        <label htmlFor="contractWithout" style={{ marginLeft: '0.5em' }}>Without (Contract PDF only)</label>
                    </div>
                </Dialog>
               { this.props.loading && <div className="page-loader"></div>}
               {/* { this.state.keywordLoading && <div className="page-loader"></div>} */}
               { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
               { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
               {/* <Toast ref={(el) => this.growl = el} /> */}
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Employee Master</h1>
               
                        <div className="p-grid">
                           

                            <div className="p-col-12  p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                <Link to="/employee-master/add/new"><Button style={{float: 'right'}} label="Add Employee Master" icon="pi pi-plus" className="ml1" /></Link>
                                }

                                {/* {(this.getAccess!==undefined && this.getAccess.deleteAccess!==false) &&
                                <Button onClick={this.delete} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                } */}
                                
                                
                                </div>                                
                            </div>

                             {/* Column Selector MultiSelect */}
                            <div className="p-col-12">
                                <div className="p-col-6">
                                    <label className="label">Select Columns:</label>
                                    <div className="mt1">
                                        <MultiSelect
                                            value={this.state.selectedColumns}
                                            options={this.state.columnOptions}
                                            onChange={this.onColumnToggle}
                                            placeholder="Choose columns to display"
                                            className="p-col-12"
                                            {...DROPDOWN_CONFIG}
                                            showClear={false} 
                                        />
                                    </div>
                                </div>
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
       
                        <DataTable value={tableData} selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                         globalFilter={this.state.globalFilter}  header={header} {...DATATABLE_CONFIG} >                                
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                   {/*New :All columns are now conditional */}
                                    {this.state.selectedColumns.includes('employeeName') && 
                                        <Column field="employeeName" header="Employee Name" sortable={true} style={{width:'12em'}} />}
                                    {this.state.selectedColumns.includes('userNo') && 
                                        <Column field="userNo" header="User No" />}
                                    {this.state.selectedColumns.includes('postiondescription') && 
                                        <Column field="postiondescription" header="Position Description"/>}
                                    {this.state.selectedColumns.includes('positionnumber') && 
                                        <Column field="positionnumber" header="Position No" />}
                                    {this.state.selectedColumns.includes('orgNo') && 
                                        <Column field="orgNo" header="Org No" />}
                                    {this.state.selectedColumns.includes('name') && 
                                        <Column field="name" header="Dept Name" />}
                                    
                                    {/* Additional columns */}
                                    {this.state.selectedColumns.includes('costcenter') && 
                                        <Column field="costcenter" header="Cost Center" />}
                                    {this.state.selectedColumns.includes('empsubgrp') && 
                                        <Column field="empsubgrplabel" header="Employee Subgroup"/>}
                                    {this.state.selectedColumns.includes('nationalityNames') && 
                                        <Column field="nationalityNames" header="Nationality" />}
                                    {this.state.selectedColumns.includes('gender') && 
                                        <Column field="gender" header="Gender" />}
                                    {this.state.selectedColumns.includes('vendor') && 
                                        <Column field="vendorname" header="Vendor" />}
                                    {this.state.selectedColumns.includes('employeetypeid') && 
                                        <Column field="employeetypeid" header="Emp Type" />}
                                    {this.state.selectedColumns.includes('employeeStatus') && 
                                        <Column field="employeeStatuslabel" header="Employee Status" />}
                                    {this.state.selectedColumns.includes('demobilizedate') && 
                                        <Column field="demobilizedateFormatted" header="Demoblize Date" />}
                                    {this.state.selectedColumns.includes('demobilizeremark') && 
                                        <Column field="demobilizeremark" header="Demoblize Remark" />}
                                  
                                    
                                <Column field="action" body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        //new
        employeesubgroup: (state.keyword && state.keyword.employeesubgroup) ? state.keyword.employeesubgroup : [],
        vendor: (state.keyword && state.keyword.vendor) ? state.keyword.vendor : [],
        employeestatus: (state.keyword.EmployeeStatus!==undefined) ? state.keyword.EmployeeStatus : [],
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        //NEW 
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(EmployeeMaster);